import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import SectionHeading from '../../Common/SectionHeading';

export default function OurPerspective({description, pointsHeading, perspectiveItems=[], title=null}) {

    const midpoint = Math.ceil(perspectiveItems?.length / 2);
    const column1 = perspectiveItems?.slice(0, midpoint);
    const column2 = perspectiveItems?.slice(midpoint);
    return (
        <>
            <div className="w-11/12 xl:max-w-screen max-w-screen-2xl mx-auto lg:my-10 my-6">
                <div className="border px-6 lg:px-10 pt-5 pb-10">
                    <SectionHeading title={title}  customClass="center" />
                    <p className="text-base">{description}</p>
                    <h4 className="text-lg font-semibold mb-4 text-[#1b5df3]">{pointsHeading}</h4>
                    <div className="flex flex-col md:flex-row">
                        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl md:w-1/2">
                            <ul>
                                {column1.map((item, index) => (
                                    <li className="flex text-base" key={index}>
                                        <div className="pr-4">
                                            <FontAwesomeIcon style={{ color: '#1b5df3', marginRight: '5px' }} icon={faCheck}/>
                                        </div>
                                        {item?.point}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="w-11/12 xl:max-w-screen max-w-screen-2xl md:w-1/2">
                            <ul>
                                {column2.map((item, index) => (
                                    <li className="flex text-base" key={index}>
                                        <div className="pr-4">
                                            <FontAwesomeIcon style={{ color: '#1b5df3', marginRight: '5px' }} icon={faCheck}/>
                                        </div>
                                        {item?.point}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
